import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";

import { Post } from "../components/Post";
import { Index } from "../components/AddComment";
import { CommentsBlock } from "../components/CommentsBlock";
import axios from "../axios";

import Button from "@mui/material/Button";

export const FullPost = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [isCommentsLoading, setIsCommentsLoading] = useState(true);
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [selectedMedia, setSelectedMedia] = useState(null);
  const handleMediaOpen = (url) => setSelectedMedia(url);
  const handleMediaClose = () => setSelectedMedia(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleDeleteComment = async (commentId) => {
    try {
      await axios.delete(`/comments/${commentId}`);
      const res = await axios.get(`/comments/${id}`);
      // Добавляем сортировку здесь
      const sortedComments = res.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setComments(sortedComments);
    } catch (err) {
      console.warn(err);
      alert("Помилка при видаленні коментаря");
    }
  };

  const handleEditComment = async (commentId, currentText) => {
    const newText = prompt("Введіть новий текст коментаря", currentText);
    if (newText && newText !== currentText) {
      try {
        await axios.patch(`/comments/${commentId}`, { text: newText });
        const res = await axios.get(`/comments/${id}`);
        // И здесь добавляем сортировку
        const sortedComments = res.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setComments(sortedComments);
      } catch (err) {
        console.warn(err);
        alert("Помилка при оновленні коментаря");
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    axios
      .get(`/posts/${id}`)
      .then((res) => {
        setData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.warn(err);
        alert("Помилка при отриманні статті");
      });
  }, [id]);

  useEffect(() => {
    axios
      .get(`/comments/${id}`)
      .then((res) => {
        // Сортируем комментарии по дате (новые сначала)
        const sortedComments = res.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setComments(sortedComments);
        setIsCommentsLoading(false);
      })
      .catch((err) => {
        console.warn(err);
        setIsCommentsLoading(false);
      });
  }, [id]);

  if (isLoading) {
    return <Post isLoading={isLoading} isFullPost />;
  }

  return (
    <>
      <Post
        id={data._id}
        title={data.title}
        videoUrl={data.videoUrl}
        imageUrl={data.imageUrl}
        user={data.user}
        createdAt={data.createdAt}
        viewsCount={data.viewsCount}
        commentsCount={comments.length}
        tags={data.tags}
        isFullPost
      >
        {data.additionalMedia?.length > 0 && (
          <div style={{ marginTop: 30 }}>
            <h3>Додаткові медіа</h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 2fr)",
                gap: 10,
                backgroundColor: "rgba(229, 224, 224, 0.9)",
              }}
            >
              {selectedMedia && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.9)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={handleMediaClose}
                >
                  <div
                    style={{
                      position: "relative",
                      maxWidth: "90%",
                      maxHeight: "90%",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {selectedMedia.match(/\.(mp4|webm|ogg|mov|avi)$/i) ? (
                      <video
                        controls
                        autoPlay
                        src={selectedMedia}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "90vh",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <img
                        src={selectedMedia}
                        alt="Увеличенное"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "90vh",
                          objectFit: "contain",
                        }}
                      />
                    )}
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleMediaClose}
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        minWidth: 40,
                        height: 40,
                        borderRadius: "50%",
                        padding: 0,
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                      }}
                    >
                      ×
                    </Button>
                  </div>
                </div>
              )}

              {data.additionalMedia
                .slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )
                .map((url, i) => {
                  const isVideo = url.match(/\.(mp4|webm|ogg|mov|avi)$/i); // Проверяем расширение
                  return (
                    <div
                      key={i}
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        height: windowWidth <= 700 ? "100px" : "200px",
                      }}
                      onClick={() => handleMediaOpen(url)}
                    >
                      {isVideo ? (
                        <video
                          controls
                          src={url}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 4,
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.transform = "scale(1.02)")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      ) : (
                        <img
                          src={url}
                          alt="Додаткове медиа"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 4,
                            transition: "transform 0.2s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.transform = "scale(1.02)")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.transform = "scale(1)")
                          }
                        />
                      )}
                    </div>
                  );
                })}
            </div>

            {data.additionalMedia.length > itemsPerPage && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 10,
                  marginTop: 15,
                }}
              >
                <Button
                  variant="contained"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Назад
                </Button>
                <Button
                  variant="contained"
                  disabled={
                    currentPage * itemsPerPage >= data.additionalMedia.length
                  }
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Вперед
                </Button>
              </div>
            )}
          </div>
        )}
        <ReactMarkdown children={data.text} />
      </Post>

      <CommentsBlock
        items={comments.map((comment) => ({
          user: {
            fullName: comment.user.fullName,
            avatarUrl: comment.user.avatarUrl,
            _id: comment.user._id,
          },
          text: comment.text,
          _id: comment._id,
          createdAt: comment.createdAt,
        }))}
        isLoading={isCommentsLoading}
        onDelete={handleDeleteComment}
        onEdit={handleEditComment}
        isFullPost={true}
      >
        <Index postId={id} />
      </CommentsBlock>
    </>
  );
};
